import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { style: {"height":"100px","border-bottom":"1px solid black","margin":"0 10px 10px"} }
const _hoisted_5 = { style: {"padding":"0 10px 10px"} }
const _hoisted_6 = {
  key: 1,
  class: "form-wrapper slide-up rv rv-modal"
}
const _hoisted_7 = { class: "form-close" }
const _hoisted_8 = { class: "rv-seathead" }
const _hoisted_9 = { class: "rv-big" }
const _hoisted_10 = { class: "rv-seathead-t" }
const _hoisted_11 = { class: "rv-sn" }
const _hoisted_12 = {
  key: 0,
  class: "rv-st"
}
const _hoisted_13 = { class: "rv-from" }
const _hoisted_14 = { class: "rv-actions" }
const _hoisted_15 = {
  key: 0,
  class: "rv-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad")!
  const _component_role_seat = _resolveComponent("role-seat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showColSignOff)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = () => { _ctx.showColSignOff = false })
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VueSignaturePad, { ref: "signOffPad" }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("b", null, "Sign Name Above", -1)),
            _cache[8] || (_cache[8] = _createTextVNode(" - ", -1)),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => { (_ctx.$refs as any).signOffPad.clearSignature() }, ["prevent"]))
            }, "Clear")
          ]),
          _withDirectives(_createElementVNode("input", {
            style: {"margin-top":"15px"},
            type: "text",
            placeholder: "Type your name",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.colSignOffInput) = $event))
          }, null, 512), [
            [_vModelText, _ctx.colSignOffInput]
          ]),
          _createElementVNode("input", {
            class: _normalizeClass(_ctx.colSignOffSubmitting ? 'disable-button' : ''),
            type: "submit",
            value: "Submit",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitColSignOff()))
          }, null, 2)
        ]))
      : (_ctx.found)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
              }, "×")
            ]),
            _createElementVNode("header", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.initials), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.seat.name || _ctx.seat.title || 'Role'), 1),
                (_ctx.seat.name && _ctx.seat.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.seat.title), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.found.node.Name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn rv-act",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showColSignOff = true))
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                  _createElementVNode("path", { d: "M3 17c3.33-3.33 5-6 5-8a3 3 0 0 0-6 0c0 3 3 4.5 4.5 6.5C7.5 16.8 8.3 18 9 18c1.5 0 2.5-3 3-3s1 2 2.5 2c.6 0 1.6-.6 2.5-2M17 20h4" })
                ], -1),
                _createTextVNode("Sign off", -1)
              ]))]),
              _createElementVNode("button", {
                type: "button",
                class: "ep-chip",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToRoleSheet()))
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                  _createElementVNode("path", { d: "M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M11 13l9-9M15 4h5v5" })
                ], -1),
                _createTextVNode("Open role sheet", -1)
              ]))])
            ]),
            _createVNode(_component_role_seat, {
              accountabilities: _ctx.found.seat.accountabilities,
              sections: _ctx.sections,
              prefix: "role-col"
            }, null, 8, ["accountabilities", "sections"]),
            (!_ctx.sections.length && !_ctx.found.seat.accountabilities.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, "This role hasn't been filled in yet."))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}